import { NgModel } from '@angular/forms';
import { Directive, ElementRef } from '@angular/core';
import {FnNumberDirective} from './fn-number.directive';


@Directive({
  selector: '[fnTemperatureDirective]',
  providers: [NgModel]
})
export class FnTemperatureDirective extends FnNumberDirective {
  constructor(model: NgModel, elementRef: ElementRef) {
    super(model, elementRef);
    this.isDecimal = true;
    this.isNegative = true;
  }
 }
